<template>
  <el-container v-loading="isLoading" class="Edit">
    <el-header class="Edit-header">
      <el-page-header @back="close" :content="title"></el-page-header>
    </el-header>
    <el-main class="Edit-main">
      <el-form :model="form" :rules="rules" ref="form" label-width="150px" :disabled="disableEdit">
        <el-form-item v-if="isSspUser" label="所属广告主" prop="advertiserId">
          <el-select :disabled="isModel===2" v-model="form.advertiserId" @change="setUser">
            <el-option v-for="(item, index) in userList" :label="item.advertiserName" :value="item.advertiserId" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创意名称" prop="ideaName" style="width: 500px">
          <el-input v-model="form.ideaName"></el-input>
          <ChangeTips :change="changes.ideaName"></ChangeTips>
        </el-form-item>
        <el-form-item label="投放单元" prop="unit">
          <el-select :disabled="isModel===2" v-model="form.unit" @change="setUnit" filterable style="width: 380px">
            <el-option v-for="(item, index) in unitList" :label="item.putUnitName" :value="item.putUnitId" :key="index"></el-option>
          </el-select>
          <ChangeTips :change="changes.unit"></ChangeTips>
        </el-form-item>
        <el-form-item label="创意类型" prop="ideaType">
          <el-select :disabled="isModel===2" v-model="form.ideaType"  @change="setIdeaType" filterable  style="width: 380px">
            <el-option v-for="(item, index) in ideaTypeList" :label="item.ideaTypeName" :value="item.ideaTypeId" :key="index"></el-option>
          </el-select>
          <ChangeTips :change="changes.ideaType"></ChangeTips>
        </el-form-item>
        <el-form-item label="出价类型" prop="bidType">
          <el-select v-model="form.bidType">
            <el-option v-for="(item, index) in bidTypeList" :label="item.name" :value="item.id" :key="index"></el-option>
          </el-select>
          <ChangeTips :change="changes.bidType"></ChangeTips>
        </el-form-item>
        <el-form-item label="目标出价" prop="simulateBid" style="width: 500px">
          <el-input v-model="form.simulateBid">
            <template slot="append">元{{form.bidType === 2 ? ' / 点击' : form.bidType === 3 ? ' / 千次展示' : form.bidType === 4 || form.bidType === 5 ? ' / 用户成本' : ''}}</template>
          </el-input>
          <ChangeTips :change="changes.simulateBid"></ChangeTips>
        </el-form-item>
        <!--创意素材-->
        <template v-for="(item, index) in assetsList">
          <el-form-item v-if="item.assetsId===1" :rules="[{ required: !!item.required, message: '请选择Icon图片', trigger: 'change' }]" label="Icon" prop="iconFile" style="width: 500px" :key="index" :error="iconErrorTip">
            <div>
              <div class="file_img">
                <div>
                  <el-image :src="iconPreview" :preview-src-list="[iconPreview]"></el-image>
                </div>
                <div>
                  <div>
                    <input ref="file_icon" type="file" :accept="item.data.mimes.join(',')" @change="setImg($event, 'icon', item.data)" title="" />
                    上传
                  </div>
                  <template v-if="iconPreview">
                    <a v-if="isModel===2" :href="iconPreview" download="">下载</a>
                    <el-button size="small" icon="el-icon-close" @click="removeImg('icon')"></el-button>
                  </template>
                </div>
              </div>
              <div class="file_taps">Icon仅限 {{item.data.mimes.join('、').replace(/image\//g, '').toUpperCase()}} 格式，宽度：{{item.data.width?item.data.width:'不限'}}，高度：{{item.data.height?item.data.height:'不限'}}</div>
            </div>
            <ChangeTips :change="changes.icon"></ChangeTips>
          </el-form-item>
          <el-form-item v-else-if="item.assetsId===2" :rules="[{ required: !!item.required, message: '请选择Logo图片', trigger: 'change' }]" label="Logo" prop="logoFile" style="width: 500px" :key="index" :error="logoErrorTip">
            <div>
              <div class="file_img">
                <div>
                  <el-image :src="logoPreview" :preview-src-list="[logoPreview]"></el-image>
                </div>
                <div>
                  <div>
                    <input ref="file_logo" type="file" :accept="item.data.mimes.join(',')" @change="setImg($event, 'logo', item.data)" title="" />
                    上传
                  </div>
                  <template v-if="logoPreview">
                    <a v-if="isModel===2" :href="logoPreview" download="">下载</a>
                    <el-button size="small" icon="el-icon-close" @click="removeImg('logo')"></el-button>
                  </template>
                </div>
              </div>
              <div class="file_taps">Logo仅限 {{item.data.mimes.join('、').replace(/image\//g, '').toUpperCase()}} 格式，宽度：{{item.data.width?item.data.width:'不限'}}，高度：{{item.data.height?item.data.height:'不限'}}</div>
            </div>
            <ChangeTips :change="changes.logo"></ChangeTips>
          </el-form-item>
          <el-form-item v-else-if="item.assetsId===3" :rules="[{ required: !!item.required, message: '请选择主图片', trigger: 'change' }]" label="主图片" prop="image1File" style="width: 500px" :key="index" :error="image1ErrorTip">
            <div>
              <div class="file_img">
                <div>
                  <el-image :src="image1Preview" :preview-src-list="[image1Preview]"></el-image>
                </div>
                <div>
                  <div>
                    <input ref="file_image1" type="file" :accept="item.data.mimes.join(',')" @change="setImg($event, 'image1', item.data)" title="" />
                    上传
                  </div>
                  <template v-if="image1Preview">
                    <a v-if="isModel===2" :href="image1Preview" download="">下载</a>
                    <el-button size="small" icon="el-icon-close" @click="removeImg('image1')"></el-button>
                  </template>
                </div>
              </div>
              <div class="file_taps">主图片仅限 {{item.data.mimes.join('、').replace(/image\//g, '').toUpperCase()}} 格式，宽度：{{item.data.width?item.data.width:'不限'}}，高度：{{item.data.height?item.data.height:'不限'}}</div>
            </div>
            <ChangeTips :change="changes.image1"></ChangeTips>
          </el-form-item>
          <el-form-item v-else-if="item.assetsId===4" :rules="[{ required: !!item.required, message: '请选择图片二', trigger: 'change' }]" label="图片二" prop="image2File" style="width: 500px" :key="index" :error="image2ErrorTip">
            <div>
              <div class="file_img">
                <div>
                  <el-image :src="image2Preview" :preview-src-list="[image2Preview]"></el-image>
                </div>
                <div>
                  <div>
                    <input ref="file_image2" type="file" :accept="item.data.mimes.join(',')" @change="setImg($event, 'image2', item.data)" title="" />
                    上传
                  </div>
                  <template v-if="image2Preview">
                    <a v-if="isModel===2" :href="image2Preview" download="">下载</a>
                    <el-button size="small" icon="el-icon-close" @click="removeImg('image2')"></el-button>
                  </template>
                </div>
              </div>
              <div class="file_taps">图片二仅限 {{item.data.mimes.join('、').replace(/image\//g, '').toUpperCase()}} 格式，宽度：{{item.data.width?item.data.width:'不限'}}，高度：{{item.data.height?item.data.height:'不限'}}</div>
            </div>
            <ChangeTips :change="changes.image2"></ChangeTips>
          </el-form-item>
          <el-form-item v-else-if="item.assetsId===5" :rules="[{ required: !!item.required, message: '请选择图片三', trigger: 'change' }]" label="图片三" prop="image3File" style="width: 500px" :key="index" :error="image3ErrorTip">
            <div>
              <div class="file_img">
                <div>
                  <el-image :src="image3Preview" :preview-src-list="[image3Preview]"></el-image>
                </div>
                <div>
                  <div>
                    <input ref="file_image3" type="file" :accept="item.data.mimes.join(',')" @change="setImg($event, 'image3', item.data)" title="" />
                    上传
                  </div>
                  <template v-if="image3Preview">
                    <a v-if="isModel===2" :href="image3Preview" download="">下载</a>
                    <el-button size="small" icon="el-icon-close" @click="removeImg('image3')"></el-button>
                  </template>
                </div>
              </div>
              <div class="file_taps">图片三仅限 {{item.data.mimes.join('、').replace(/image\//g, '').toUpperCase()}} 格式，宽度：{{item.data.width?item.data.width:'不限'}}，高度：{{item.data.height?item.data.height:'不限'}}</div>
            </div>
            <ChangeTips :change="changes.image3"></ChangeTips>
          </el-form-item>
          <el-form-item v-else-if="item.assetsId===6" :rules="[
          { required: !!item.required, message: '请输入标题', trigger: 'blur' },
          { min: item.data.minLen?parseInt(item.data.minLen):0, max: item.data.maxLen?parseInt(item.data.maxLen):maxfontNumber, message: `长度在 ${item.data.minLen?item.data.minLen:0} 到 ${item.data.maxLen?item.data.maxLen:maxfontNumber} 个字符`, trigger: 'blur' }
          ]" label="标题" prop="title" style="width: 500px" :key="index">
            <el-input v-model="form.title"></el-input>
            <ChangeTips :change="changes.title"></ChangeTips>
          </el-form-item>
          <el-form-item v-else-if="item.assetsId===7" :rules="[
          { required: !!item.required, message: '请输入描述', trigger: 'blur' },
          { min: item.data.minLen?parseInt(item.data.minLen):0, max: item.data.maxLen?parseInt(item.data.maxLen):maxfontNumber, message: `长度在 ${item.data.minLen?item.data.minLen:0} 到 ${item.data.maxLen?item.data.maxLen:maxfontNumber} 个字符`, trigger: 'blur' }
          ]" label="描述" prop="desc" style="width: 500px" :key="index">
            <el-input v-model="form.desc"></el-input>
            <ChangeTips :change="changes.desc"></ChangeTips>
          </el-form-item>
          <el-form-item v-else-if="item.assetsId===8" :rules="[
          { required: !!item.required, message: '请输入评分', trigger: 'blur' },
          { min: item.data.minLen?parseInt(item.data.minLen):0, max: item.data.maxLen?parseInt(item.data.maxLen):maxfontNumber, message: `长度在 ${item.data.minLen?item.data.minLen:0} 到 ${item.data.maxLen?item.data.maxLen:maxfontNumber} 个字符`, trigger: 'blur' }
          ]" label="评分" prop="rating" style="width: 500px" :key="index">
            <el-input v-model="form.rating"></el-input>
            <ChangeTips :change="changes.rating"></ChangeTips>
          </el-form-item>
          <el-form-item v-else-if="item.assetsId===9" :rules="[
          { required: !!item.required, message: '请输入好评数', trigger: 'blur' },
          { min: item.data.minLen?parseInt(item.data.minLen):0, max: item.data.maxLen?parseInt(item.data.maxLen):maxfontNumber, message: `长度在 ${item.data.minLen?item.data.minLen:0} 到 ${item.data.maxLen?item.data.maxLen:maxfontNumber} 个字符`, trigger: 'blur' }
          ]" label="好评数" prop="comments" style="width: 500px" :key="index">
            <el-input v-model="form.comments"></el-input>
            <ChangeTips :change="changes.comments"></ChangeTips>
          </el-form-item>
          <el-form-item v-else-if="item.assetsId===10" :rules="[
          { required: !!item.required, message: '请输入落地页链接', trigger: 'blur' },
          { min: item.data.minLen?parseInt(item.data.minLen):0, max: item.data.maxLen?parseInt(item.data.maxLen):maxfontNumber, message: `长度在 ${item.data.minLen?item.data.minLen:0} 到 ${item.data.maxLen?item.data.maxLen:maxfontNumber} 个字符`, trigger: 'blur' }
          ]" label="落地页链接" prop="targetUrl" style="width: 500px" :key="index">
            <el-input type="url" v-model="form.targetUrl"></el-input>
            <ChangeTips :change="changes.targetUrl"></ChangeTips>
          </el-form-item>
          <el-form-item v-else-if="item.assetsId===11" :rules="[
          { required: !!item.required, message: '请输入APP名称', trigger: 'blur' },
          { min: item.data.minLen?parseInt(item.data.minLen):0, max: item.data.maxLen?parseInt(item.data.maxLen):maxfontNumber, message: `长度在 ${item.data.minLen?item.data.minLen:0} 到 ${item.data.maxLen?item.data.maxLen:maxfontNumber} 个字符`, trigger: 'blur' }
          ]" label="APP名称" prop="appName" style="width: 500px" :key="index">
            <el-input v-model="form.appName"></el-input>
            <ChangeTips :change="changes.appName"></ChangeTips>
          </el-form-item>
          <el-form-item v-else-if="item.assetsId===12" :rules="[
          { required: !!item.required, message: '请输入APP下载链接', trigger: 'blur' },
          { min: item.data.minLen?parseInt(item.data.minLen):0, max: item.data.maxLen?parseInt(item.data.maxLen):maxfontNumber, message: `长度在 ${item.data.minLen?item.data.minLen:0} 到 ${item.data.maxLen?item.data.maxLen:maxfontNumber} 个字符`, trigger: 'blur' }
          ]" label="APP下载链接" prop="appDownUrl" style="width: 500px" :key="index">
            <el-input type="url" v-model="form.appDownUrl"></el-input>
            <ChangeTips :change="changes.appDownUrl"></ChangeTips>
          </el-form-item>
          <el-form-item v-else-if="item.assetsId===13" :rules="[
          { required: !!item.required, message: '请输入打开应用URL', trigger: 'blur' },
          { min: item.data.minLen?parseInt(item.data.minLen):0, max: item.data.maxLen?parseInt(item.data.maxLen):maxfontNumber, message: `长度在 ${item.data.minLen?item.data.minLen:0} 到 ${item.data.maxLen?item.data.maxLen:maxfontNumber} 个字符`, trigger: 'blur' }
          ]" label="打开应用URL" prop="deeplink" style="width: 500px" :key="index">
            <el-input type="url" v-model="form.deeplink"></el-input>
            <ChangeTips :change="changes.deeplink"></ChangeTips>
          </el-form-item>
          <el-form-item v-else-if="item.assetsId===14" :rules="[
          { required: !!item.required, message: '请输入APP包名', trigger: 'blur' },
          { min: item.data.minLen?parseInt(item.data.minLen):0, max: item.data.maxLen?parseInt(item.data.maxLen):maxfontNumber, message: `长度在 ${item.data.minLen?item.data.minLen:0} 到 ${item.data.maxLen?item.data.maxLen:maxfontNumber} 个字符`, trigger: 'blur' }
          ]" label="APP包名" prop="packageName" style="width: 500px" :key="index">
            <el-input v-model="form.packageName"></el-input>
            <ChangeTips :change="changes.packageName"></ChangeTips>
          </el-form-item>
          <el-form-item v-else-if="item.assetsId===15" :class="{'is-required': !!item.required}" label="展示监控" prop="showMonitor" style="width: 500px;margin-bottom: 80px" :key="index" :error="showMonitorTip">
            <el-input v-for="(item1, index1) in form.showMonitor" v-model="form.showMonitor[index1]" :key="index1" class="mt10" @blur="urlRule('showMonitor', '展示监控', index1, {required: !!item.required, min: item.data.minLen, max: item.data.maxLen})"><el-button v-if="index1 > 0" slot="append" icon="el-icon-close" @click="deleteValue('showMonitor', index1)"></el-button></el-input>
            <el-button type="primary" plain @click="setUrlInput('showMonitor')" style="position: absolute;bottom: -60px;left: 0;">添加URL</el-button>
            <i class="el-icon-question" style="position: absolute;top: 12px;left: 101%;font-size: 20px;cursor: pointer" title="点击查看宏参数列表" @click="openMacroDialog(true)"></i>
            <ChangeTips :change="changes.showMonitor"></ChangeTips>
          </el-form-item>
          <el-form-item v-else-if="item.assetsId===16" :class="{'is-required': !!item.required}" label="点击监控" prop="clickMonitor" style="width: 500px;margin-bottom: 80px" :key="index" :error="clickMonitorTip">
            <el-input v-for="(item1, index1) in form.clickMonitor" v-model="form.clickMonitor[index1]" :key="index1" class="mt10" @blur="urlRule('clickMonitor', '展示监控', index1, {required: !!item.required, min: item.data.minLen, max: item.data.maxLen})"><el-button v-if="index1 > 0" slot="append" icon="el-icon-close" @click="deleteValue('clickMonitor', index1)"></el-button></el-input>
            <el-button type="primary" plain @click="setUrlInput('clickMonitor')" style="position: absolute;bottom: -60px;left: 0;">添加URL</el-button>
            <i class="el-icon-question" style="position: absolute;top: 12px;left: 101%;font-size: 20px;cursor: pointer" title="点击查看宏参数列表" @click="openMacroDialog(false)"></i>
            <ChangeTips :change="changes.clickMonitor"></ChangeTips>
          </el-form-item>
          <el-form-item v-else-if="item.assetsId===17" :rules="[{ required: !!item.required, message: '请选择视频', trigger: 'change' }]" label="视频" prop="video" style="width: 500px" :key="index" :error="videoErrorTip">
            <div>
              <a href="javascript:;" class="file el-input__inner">
                <video v-if="videoPreview" class="img_preview" :src="videoPreview" width="100%" height="auto" muted autoplay loop>您的浏览器不支持 video 标签</video>
                <input type="file" :accept="item.data.mimes.join(',')" @change="setVideo($event, item.data)" title="" />
              </a>
              <el-button icon="el-icon-close" @click="removeVideo()"></el-button>
              <div class="file_taps">视频仅限 {{item.data.mimes.join('、').replace(/video\//g, '').toUpperCase()}} 格式，宽度：{{item.data.width?item.data.width:'不限'}}，高度：{{item.data.height?item.data.height:'不限'}}，最小时长：{{item.data.minTime?item.data.minTime:'不限'}}，最大时长：{{item.data.maxTime?item.data.maxTime:'不限'}}</div>
            </div>
            <ChangeTips :change="changes.video"></ChangeTips>
          </el-form-item>
          <el-form-item v-else-if="item.assetsId===18" :rules="[
          { required: !!item.required, message: '请输入APP版本', trigger: 'blur' },
          { min: item.data.minLen?parseInt(item.data.minLen):0, max: item.data.maxLen?parseInt(item.data.maxLen):maxfontNumber, message: `长度在 ${item.data.minLen?item.data.minLen:0} 到 ${item.data.maxLen?item.data.maxLen:maxfontNumber} 个字符`, trigger: 'blur' }
          ]" label="APP版本" prop="appVersion" style="width: 500px" :key="index" >
            <el-input v-model="form.appVersion"></el-input>
            <ChangeTips :change="changes.appVersion"></ChangeTips>
          </el-form-item>
          <el-form-item v-else-if="item.assetsId===19" :rules="[
          { required: !!item.required, message: '请输入APP开发者', trigger: 'blur' },
          { min: item.data.minLen?parseInt(item.data.minLen):0, max: item.data.maxLen?parseInt(item.data.maxLen):maxfontNumber, message: `长度在 ${item.data.minLen?item.data.minLen:0} 到 ${item.data.maxLen?item.data.maxLen:maxfontNumber} 个字符`, trigger: 'blur' }
          ]" label="APP开发者" prop="appDeveloper" style="width: 500px" :key="index" >
            <el-input v-model="form.appDeveloper"></el-input>
            <ChangeTips :change="changes.appDeveloper"></ChangeTips>
          </el-form-item>
          <el-form-item v-else-if="item.assetsId===20" :rules="[
          { required: !!item.required, message: '请输入APP功能描述URL', trigger: 'blur' },
          { min: item.data.minLen?parseInt(item.data.minLen):0, max: item.data.maxLen?parseInt(item.data.maxLen):maxfontNumber, message: `长度在 ${item.data.minLen?item.data.minLen:0} 到 ${item.data.maxLen?item.data.maxLen:maxfontNumber} 个字符`, trigger: 'blur' }
          ]" label="APP功能描述URL" prop="appFeatureUrl" style="width: 500px" :key="index" >
            <el-input v-model="form.appFeatureUrl"></el-input>
            <ChangeTips :change="changes.appFeatureUrl"></ChangeTips>
          </el-form-item>
          <el-form-item v-else-if="item.assetsId===21" :rules="[
          { required: !!item.required, message: '请输入APP隐私政策URL', trigger: 'blur' },
          { min: item.data.minLen?parseInt(item.data.minLen):0, max: item.data.maxLen?parseInt(item.data.maxLen):maxfontNumber, message: `长度在 ${item.data.minLen?item.data.minLen:0} 到 ${item.data.maxLen?item.data.maxLen:maxfontNumber} 个字符`, trigger: 'blur' }
          ]" label="APP隐私政策URL" prop="appPrivacyPolicyUrl" style="width: 500px" :key="index" >
            <el-input v-model="form.appPrivacyPolicyUrl"></el-input>
            <ChangeTips :change="changes.appPrivacyPolicyUrl"></ChangeTips>
          </el-form-item>
          <el-form-item v-else-if="item.assetsId===22" :rules="[
          { required: !!item.required, message: '请输入APP权限列表URL', trigger: 'blur' },
          { min: item.data.minLen?parseInt(item.data.minLen):0, max: item.data.maxLen?parseInt(item.data.maxLen):maxfontNumber, message: `长度在 ${item.data.minLen?item.data.minLen:0} 到 ${item.data.maxLen?item.data.maxLen:maxfontNumber} 个字符`, trigger: 'blur' }
          ]" label="APP权限列表URL" prop="appPermissionUrl" style="width: 500px" :key="index" >
            <el-input v-model="form.appPermissionUrl"></el-input>
            <ChangeTips :change="changes.appPermissionUrl"></ChangeTips>
          </el-form-item>
          <el-form-item v-else-if="item.assetsId===23" :class="{'is-required': !!item.required}" label="下载开始监控" prop="downloadStartMonitor" style="width: 500px;margin-bottom: 80px" :key="index" :error="downloadStartMonitorTip">
            <el-input v-for="(item1, index1) in form.downloadStartMonitor" v-model="form.downloadStartMonitor[index1]" :key="index1" class="mt10" @blur="urlRule('downloadStartMonitor', '下载开始监控', index1, {required: !!item.required, min: item.data.minLen, max: item.data.maxLen})"><el-button v-if="index1 > 0" slot="append" icon="el-icon-close" @click="deleteValue('downloadStartMonitor', index1)"></el-button></el-input>
            <el-button type="primary" plain @click="setUrlInput('downloadStartMonitor')" style="position: absolute;bottom: -60px;left: 0;">添加URL</el-button>
            <i class="el-icon-question" style="position: absolute;top: 12px;left: 101%;font-size: 20px;cursor: pointer" title="点击查看宏参数列表" @click="openMacroDialog(false)"></i>
            <ChangeTips :change="changes.downloadStartMonitor"></ChangeTips>
          </el-form-item>
          <el-form-item v-else-if="item.assetsId===24" :class="{'is-required': !!item.required}" label="下载完成监控" prop="downloadFinishMonitor" style="width: 500px;margin-bottom: 80px" :key="index" :error="downloadFinishMonitorTip">
            <el-input v-for="(item1, index1) in form.downloadFinishMonitor" v-model="form.downloadFinishMonitor[index1]" :key="index1" class="mt10" @blur="urlRule('downloadFinishMonitor', '下载完成监控', index1, {required: !!item.required, min: item.data.minLen, max: item.data.maxLen})"><el-button v-if="index1 > 0" slot="append" icon="el-icon-close" @click="deleteValue('downloadFinishMonitor', index1)"></el-button></el-input>
            <el-button type="primary" plain @click="setUrlInput('downloadFinishMonitor')" style="position: absolute;bottom: -60px;left: 0;">添加URL</el-button>
            <i class="el-icon-question" style="position: absolute;top: 12px;left: 101%;font-size: 20px;cursor: pointer" title="点击查看宏参数列表" @click="openMacroDialog(false)"></i>
            <ChangeTips :change="changes.downloadFinishMonitor"></ChangeTips>
          </el-form-item>
          <el-form-item v-else-if="item.assetsId===25" :class="{'is-required': !!item.required}" label="安装开始监控" prop="installStartMonitor" style="width: 500px;margin-bottom: 80px" :key="index" :error="installStartMonitorTip">
            <el-input v-for="(item1, index1) in form.installStartMonitor" v-model="form.installStartMonitor[index1]" :key="index1" class="mt10" @blur="urlRule('installStartMonitor', '安装开始监控', index1, {required: !!item.required, min: item.data.minLen, max: item.data.maxLen})"><el-button v-if="index1 > 0" slot="append" icon="el-icon-close" @click="deleteValue('installStartMonitor', index1)"></el-button></el-input>
            <el-button type="primary" plain @click="setUrlInput('installStartMonitor')" style="position: absolute;bottom: -60px;left: 0;">添加URL</el-button>
            <i class="el-icon-question" style="position: absolute;top: 12px;left: 101%;font-size: 20px;cursor: pointer" title="点击查看宏参数列表" @click="openMacroDialog(false)"></i>
            <ChangeTips :change="changes.installStartMonitor"></ChangeTips>
          </el-form-item>
          <el-form-item v-else-if="item.assetsId===26" :class="{'is-required': !!item.required}" label="安装完成监控" prop="installFinishMonitor" style="width: 500px;margin-bottom: 80px" :key="index" :error="installFinishMonitorTip">
            <el-input v-for="(item1, index1) in form.installFinishMonitor" v-model="form.installFinishMonitor[index1]" :key="index1" class="mt10" @blur="urlRule('installFinishMonitor', '安装完成监控', index1, {required: !!item.required, min: item.data.minLen, max: item.data.maxLen})"><el-button v-if="index1 > 0" slot="append" icon="el-icon-close" @click="deleteValue('installFinishMonitor', index1)"></el-button></el-input>
            <el-button type="primary" plain @click="setUrlInput('installFinishMonitor')" style="position: absolute;bottom: -60px;left: 0;">添加URL</el-button>
            <i class="el-icon-question" style="position: absolute;top: 12px;left: 101%;font-size: 20px;cursor: pointer" title="点击查看宏参数列表" @click="openMacroDialog(false)"></i>
            <ChangeTips :change="changes.installFinishMonitor"></ChangeTips>
          </el-form-item>
        </template>
        <!--拉活策略-->
        <template v-if="form.unit.indexOf(':8')>-1">
          <el-form-item label="生效时间" prop="effectTime" :rules="[{ required: true, message: '请选择生效时间', trigger: 'change' }]">
            <el-date-picker v-model="form.effectTime" type="datetime" placeholder="选择日期时间"></el-date-picker>
            <ChangeTips :change="changes.effectTime"></ChangeTips>
          </el-form-item>
          <el-form-item label="过期时间" prop="expiredTime" :rules="[{ required: true, message: '请选择过期时间', trigger: 'change' }]">
            <el-date-picker v-model="form.expiredTime" type="datetime" placeholder="选择日期时间"></el-date-picker>
            <ChangeTips :change="changes.expiredTime"></ChangeTips>
          </el-form-item>
          <el-form-item label="前台显示概率" prop="showRatio" :rules="[{ required: true, message: '请选择前台显示概率', trigger: 'change' }]">
            <el-select v-model="form.showRatio">
              <el-option v-for="(item, index) in showRatioList" :value="item" :key="index"></el-option>
            </el-select>
            <ChangeTips :change="changes.showRatio"></ChangeTips>
          </el-form-item>
          <el-form-item v-for="(item, index) in form.executeTime" :label="`执行时间${index}`" :key="item.key" :prop="`executeTime.${index}.value`" :rules="[{ required: true, message: '请选择执行时间', trigger: 'change' }]">
            <el-time-picker  v-model="item.value"></el-time-picker>
            <el-select v-model="item.radio" style="width: 100px">
              <el-option v-for="(item, index) in ratioList" :label="`${item}%`" :value="item" :key="index"></el-option>
            </el-select>
            <el-button @click.prevent="removeItem(item)">删除</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="addItem">新增执行时间</el-button>
          </el-form-item>
          <el-form-item label="拉活触发策略" prop="triggerWay" :rules="[{ required: true, message: '请选择拉活触发策略', trigger: 'change' }]">
            <el-select v-model="form.triggerWay">
              <el-option v-for="(item, index) in myOption.triggerWay" :label="item.name" :value="item.id" :key="index"></el-option>
            </el-select>
            <ChangeTips :change="changes.triggerWay"></ChangeTips>
          </el-form-item>
          <el-form-item v-show="form.triggerWay===1" label="定时触发策略" prop="timeWay" :rules="[{ required: form.triggerWay===1?true:false, message: '请选择定时触发策略', trigger: 'change' }]">
            <el-select v-model="form.timeWay">
              <el-option v-for="(item, index) in myOption.timeWay" :label="item.name" :value="item.id" :key="index"></el-option>
            </el-select>
            <ChangeTips :change="changes.timeWay"></ChangeTips>
          </el-form-item>
          <el-form-item v-show="form.triggerWay===1&&form.timeWay===1" :label="myOption.timeWay[0].name" prop="speedTimes" :rules="[{ required: form.timeWay===1?true:false, message: `请选择${this.myOption.timeWay[0].name}`, trigger: 'change' }]">
            <el-select v-model="form.speedTimes">
              <el-option v-for="(item, index) in speedTimesList" :value="item" :key="index"></el-option>
            </el-select>
            <ChangeTips :change="changes.speedTimes"></ChangeTips>
          </el-form-item>
          <el-form-item v-show="form.triggerWay===1&&form.timeWay===2" :label="myOption.timeWay[1].name" prop="timeBucket" :rules="[{ required: form.timeWay===2?true:false, message: `请选择${this.myOption.timeWay[1].name}`, trigger: 'change' }]">
            <el-select v-model="form.timeBucket">
              <el-option v-for="(item, index) in timeBucketList" :value="item" :key="index"></el-option>
            </el-select>
            <ChangeTips :change="changes.timeBucket"></ChangeTips>
          </el-form-item>
        </template>
        <el-form-item label="每日最大展示数" prop="dayShowNum" style="width: 500px">
          <el-input v-model="form.dayShowNum"></el-input>
          <ChangeTips :change="changes.dayShowNum"></ChangeTips>
        </el-form-item>
        <el-form-item label="每日最大点击数" prop="dayClickNum" style="width: 500px">
          <el-input v-model="form.dayClickNum"></el-input>
          <ChangeTips :change="changes.dayClickNum"></ChangeTips>
        </el-form-item>
        <el-form-item label="备注" prop="remark" style="width: 500px">
          <el-input type="textarea" v-model="form.remark" maxlength="200" show-word-limit></el-input>
          <ChangeTips :change="changes.remark"></ChangeTips>
        </el-form-item>
        <el-form-item>
          <el-button v-if="!isViewMode && !isAuditMode" type="primary" @click="submitForm('form')">提交</el-button>
          <el-button v-if="!isViewMode && !isAuditMode && isModel!==2" @click="resetForm('form')">重置</el-button>
        </el-form-item>
      </el-form>

      <el-divider v-if="isAuditMode && isSspUser"></el-divider>
      <el-form :model="auditForm" ref="auditForm" label-width="150px" v-if="isAuditMode && isSspUser">
        <el-form-item label="是否通过" prop="auditResult" style="width: 500px" :error="auditResultTip">
          <el-radio-group v-model="auditForm.auditResult">
            <el-radio :label="1">通过</el-radio>
            <el-radio :label="2">不通过</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="原因" prop="auditReason" style="width: 500px">
          <el-input v-model="auditForm.auditReason" maxlength="100" show-word-limit placeholder="请输入原因" style="margin-top: 10px"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('form', 1)">提交</el-button>
        </el-form-item>
      </el-form>

      <el-dialog title="宏参数列表" :visible.sync="showMacroDialog" width="1110px">
        <el-table :data="macroList" height="50vh">
          <el-table-column prop="name" label="宏参数" width="200"></el-table-column>
          <el-table-column prop="desc" label="参数描述" width="800"></el-table-column>
          <!--
          <el-table-column prop="required" label="必填" width="100">
            <template slot-scope="scope">
              <div>
                <div v-if="scope.row.required === 1" style="color: red;">是</div>
                <div v-else>否</div>
              </div>
            </template>
          </el-table-column>
          -->
        </el-table>
      </el-dialog>

    </el-main>
  </el-container>
</template>

<script>
import ChangeTips from './ChangeTips.vue'
import _ from 'lodash'
import ideaAPI from '../../api/idea'

export default {
  name: 'Edit',
  components: {
    ChangeTips
  },
  data () {
    let ideaNameRule = (rule, value, callback) => {
      if (this.isSspUser && this.form.advertiserId === '') {
        callback(new Error('请先选择所属广告主'))
      } else {
        if (value === '') {
          callback(new Error('请输入创意名称'))
        } else {
          if (value.length < 1 || value.length > 100) {
            callback(new Error('长度在 1 到 100 个字符'))
          } else {
            if (this.isModel !== 2 || this.oldName !== value) {
              this.$axios({
                method: 'post',
                headers: {
                  'Authorization': this.$store.state.user.token,
                  'ModuleId': this.thisModule.id
                },
                url: this.myOption.requestUrl + this.thisModule.exists,
                data: this.qs.stringify({
                  advertiserId: this.form.advertiserId,
                  ideaName: value
                })
              }).then((res) => {
                let code = res.data.code
                if (code === 200) {
                  if (res.data.data.exists) {
                    callback(new Error('创意名称已存在'))
                  } else {
                    callback()
                  }
                } else {
                  this.myOption.abnormalCode(this, code)
                }
              }).catch((err) => {
                this.myOption.abnormalCode(this, err)
              })
            } else {
              callback()
            }
          }
        }
      }
    }
    let bidTypeRule = (rule, value, callback) => {
      const str = `${value}`
      if (str === '') {
        callback(new Error('请输入价格'))
      } else {
        if (!/^[0-9]{0,}[.]{0,1}[0-9]{0,}$/.test(str) || (str.indexOf('.') > -1 && str.split('.')[1].length > 2) || str[str.length - 1] === '.') {
          callback(new Error('价格必须为正数，最多保留两位小数'))
        } else {
          callback()
        }
      }
    }
    let integerRule = (rule, value, callback) => {
      if (value && (value <= 0 || !/^[0-9]+$/.test(value))) {
        callback(new Error('请输入大于0的整数'))
      } else {
        callback()
      }
    }
    return {
      id: '',
      title: '',
      oldName: '',
      thisModule: {},
      isModel: this.$store.getters.isEditId,
      isViewMode: this.$store.getters.isViewMode,
      isAuditMode: this.$store.getters.isAuditMode,
      isSspUser: this.$store.getters.isMediaOwner,
      isLoading: false,
      unitList: [],
      ideaTypeList: [],
      bidTypeList: [],
      userList: [],
      assetsList: [],
      iconPreview: '',
      logoPreview: '',
      image1Preview: '',
      image2Preview: '',
      image3Preview: '',
      videoPreview: '',
      iconErrorTip: '',
      logoErrorTip: '',
      image1ErrorTip: '',
      image2ErrorTip: '',
      image3ErrorTip: '',
      videoErrorTip: '',
      maxfontNumber: 9999,
      showRatioList: [],
      speedTimesList: [],
      timeBucketList: [],
      ratioList: [],
      detailInfo: {},
      form: {
        ideaName: '',
        unit: '',
        ideaType: '',
        bidType: '',
        simulateBid: '',
        advertiserId: '',
        iconFile: '',
        logoFile: '',
        image1File: '',
        image2File: '',
        image3File: '',
        title: '',
        desc: '',
        rating: '',
        comments: '',
        targetUrl: '',
        appName: '',
        appDownUrl: '',
        appVersion: '',
        appDeveloper: '',
        appFeatureUrl: '',
        appPrivacyPolicyUrl: '',
        appPermissionUrl: '',
        deeplink: '',
        packageName: '',
        effectTime: '',
        expiredTime: '',
        showRatio: '',
        triggerWay: '',
        timeWay: '',
        executeTime: [{
          value: '',
          radio: 0
        }],
        speedTimes: '',
        timeBucket: '',
        dayShowNum: '',
        dayClickNum: '',
        remark: '',
        showMonitor: [''],
        clickMonitor: [''],
        downloadStartMonitor: [''],
        downloadFinishMonitor: [''],
        installStartMonitor: [''],
        installFinishMonitor: [''],
        video: '',
        verifyStatus: '',
        verifyIdeaInfo: {},
        updateFiledList: []
      },
      auditForm: {
        ideaId: '',
        auditResult: '',
        auditReason: ''
      },
      changes: {
        appName: {}
      },
      showMonitorTip: '',
      clickMonitorTip: '',
      downloadStartMonitorTip: '',
      downloadFinishMonitorTip: '',
      installStartMonitorTip: '',
      installFinishMonitorTip: '',
      auditResultTip: '',
      showMonitorRule: null,
      clickMonitorRule: null,
      downloadStartMonitorRule: null,
      downloadFinishMonitorRule: null,
      installStartMonitorRule: null,
      installFinishMonitorRule: null,

      showMacroDialog: false,
      macroList: [],

      rules: {
        advertiserId: [
          { required: true, message: '请选择所属广告主', trigger: 'change' }
        ],
        ideaName: [
          { required: true, validator: ideaNameRule, trigger: 'blur' }
        ],
        unit: [
          { required: true, message: '请选择投放单元', trigger: 'change' }
        ],
        ideaType: [
          { required: true, message: '请选择创意类型', trigger: 'change' }
        ],
        bidType: [
          { required: true, message: '请选择出价类型', trigger: 'change' }
        ],
        simulateBid: [
          { required: true, validator: bidTypeRule, trigger: 'blur' }
        ],
        dayShowNum: [
          { required: false, validator: integerRule, trigger: 'blur' }
        ],
        dayClickNum: [
          { required: false, validator: integerRule, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    disableEdit () {
      if (this.isAuditMode) { // 审核页面：可以修改
        return false
      }
      return this.form.verifyStatus === 0 || (this.form.verifyStatus === 2 && this.isSspUser) || this.isViewMode
    }
  },
  created () {
    if (!this.isSspUser) {
      this.form.advertiserId = this.$store.state.user.info.advertiserId
    }
    let thisModule = this.myOption.requestModule.idea.children
    if (this.isModel === 2) {
      this.title = '修改创意'
      this.thisModule = thisModule.modify
      this.thisModule.detail = thisModule.detail
      this.id = this.$store.state.user.editId
      this.isLoading = true
      this.getDetail()
    } else {
      this.title = '新建创意'
      this.thisModule = thisModule.add
      if (this.isModel === 3) { // 复制
        this.thisModule.detail = thisModule.detail
        this.id = this.$store.state.user.editId
        this.isLoading = true
        this.getDetail()
      }
    }

    if (this.isViewMode) {
      this.title = '查看创意'
    } else if (this.isAuditMode) {
      this.title = '审核创意'
    }
    if (this.isSspUser) {
      this.getUserList()
    } else {
      this.getUnitList()
    }
    let showRatioList = []
    let speedTimesList = []
    let timeBucketList = []
    let ratioList = []
    for (let i = 0; i <= 200; i++) {
      if (i >= 1 && i <= 24) {
        timeBucketList.push(i)
      }
      if (i <= 100) {
        showRatioList.push(i)
        ratioList.push(i)
      }
      speedTimesList.push(i)
    }
    this.showRatioList = showRatioList
    this.speedTimesList = speedTimesList
    this.timeBucketList = timeBucketList
    this.ratioList = ratioList
  },
  mounted () {
    if (!this.isViewMode) {
      setTimeout(() => {
        this.$nextTick(() => {
          (this.detailInfo.updateFiledList || []).forEach(fieldName => {
            let changeValue = this.getChangeValue(this.detailInfo, fieldName)
            let type = this.isImageField(fieldName) ? 'image' : ''
            if (!type) {
              type = this.isVideoField(fieldName) ? 'video' : ''
            }
            let change = { type: type || 'text', tip: changeValue }
            if (change.type === 'image') {
              change.src = changeValue
              change.preview_src_list = [changeValue]
            } else if (change.type === 'video') {
              change.src = changeValue
            }
            this.$set(this.changes, fieldName, change)
          })
        })
      }, 1000)
    }
  },
  methods: {
    openMacroDialog (filterCallback) {
      this.showMacroDialog = true
      this.macroList = this.myOption.macroList
      if (filterCallback) {
        this.macroList = this.macroList.filter(item => item.name !== '__CALLBACK__')
      }
    },
    isImageField (fieldName) {
      return fieldName && (fieldName.startsWith('image') || fieldName === 'icon' || fieldName === 'logo')
    },
    isVideoField (fieldName) {
      return fieldName && (fieldName === 'video')
    },
    getChangeValue (entity, fieldName) {
      let value = entity[fieldName]
      if (value === undefined) {
        let assetsInfo = (JSON.parse(entity['assets']) || {})
        // console.log('assetsInfo', assetsInfo)
        if (this.isImageField(fieldName)) {
          value = assetsInfo[fieldName].url
        } else if (this.isVideoField(fieldName)) {
          value = assetsInfo[fieldName].video_url
        } else {
          value = assetsInfo[fieldName]
        }
      }

      if (fieldName === 'bidType') {
        value = this.myOption.bidType.find(item => item.id === value).name
      }

      return value
    },
    close () {
      this.myOption.switchListAndEdit(this, true)
    },
    // 获取广告主列表
    getUserList () {
      this.isLoading = true
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.thisModule.id
        },
        url: this.myOption.requestUrl + this.thisModule.user,
        data: this.qs.stringify({
          startPage: 1,
          pageSize: this.myOption.pageSize.max
        })
      }).then((res) => {
        let code = res.data.code
        if (code === 200) {
          this.userList = res.data.data.data
          this.isLoading = false
        } else {
          this.myOption.abnormalCode(this, code)
        }
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
      })
    },
    // 设置广告主
    setUser () {
      this.form.ideaName = ''
      this.form.unit = ''
      this.form.ideaType = ''
      this.form.bidType = ''
      this.getUnitList()
    },
    // 获取投放单元列表
    getUnitList () {
      let param = {
        startPage: 1,
        pageSize: this.myOption.pageSize.max
      }
      if (this.isSspUser) {
        param.advertiserId = this.form.advertiserId
      }
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.thisModule.id
        },
        url: this.myOption.requestUrl + this.thisModule.unit,
        data: this.qs.stringify(param)
      }).then((res) => {
        let code = res.data.code
        if (code === 200) {
          let data = res.data.data.data
          for (let val of data) {
            val.putUnitId = `${val.putUnitId}:${val.slotType}`
          }
          this.unitList = data
        } else {
          this.myOption.abnormalCode(this, code)
        }
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
      })
    },
    // 设置投放单元
    setUnit (value) {
      let id = value.split(':')[1]
      this.form.ideaType = ''
      this.form.bidType = ''
      this.form.simulateBid = ''
      this.form.remark = ''
      this.form.title = ''
      this.form.desc = ''
      this.form.rating = ''
      this.form.comments = ''
      this.form.targetUrl = ''
      this.form.appName = ''
      this.form.appDownUrl = ''
      this.form.appVersion = ''
      this.form.appDeveloper = ''
      this.form.appFeatureUrl = ''
      this.form.appPrivacyPolicyUrl = ''
      this.form.appPermissionUrl = ''
      this.form.deeplink = ''
      this.form.packageName = ''
      this.form.iconFile = ''
      this.form.logoFile = ''
      this.form.image1File = ''
      this.form.image2File = ''
      this.form.image3File = ''
      this.form.effectTime = ''
      this.form.expiredTime = ''
      this.form.showRatio = ''
      this.form.executeTime = [{value: '', radio: 0}]
      this.form.triggerWay = ''
      this.form.timeWay = ''
      this.form.speedTimes = ''
      this.assetsList = []
      this.iconPreview = ''
      this.logoPreview = ''
      this.image1Preview = ''
      this.image2Preview = ''
      this.image3Preview = ''
      this.form.dayShowNum = ''
      this.form.dayClickNum = ''
      this.getIdeaTypeList(id)
      if (id === '8') {
        // 拉活广告
        this.bidTypeList = [this.myOption.bidType[0]]
      } else {
        // 非拉活广告
        this.bidTypeList = [
          this.myOption.bidType[1],
          this.myOption.bidType[2],
          this.myOption.bidType[3],
          this.myOption.bidType[4]
        ]
      }
    },
    // 获取创意类型列表
    getIdeaTypeList (id) {
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.thisModule.id
        },
        url: this.myOption.requestUrl + this.thisModule.type,
        data: this.qs.stringify({
          slotType: id,
          startPage: 1,
          pageSize: this.myOption.pageSize.max
        })
      }).then((res) => {
        let code = res.data.code
        if (code === 200) {
          this.ideaTypeList = res.data.data.data
        } else {
          this.myOption.abnormalCode(this, code)
        }
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
      })
    },
    // 设置创意类型
    setIdeaType (value) {
      this.form.title = ''
      this.form.desc = ''
      this.form.rating = ''
      this.form.comments = ''
      this.form.targetUrl = ''
      this.form.appName = ''
      this.form.appDownUrl = ''
      this.form.appVersion = ''
      this.form.appDeveloper = ''
      this.form.appFeatureUrl = ''
      this.form.appPrivacyPolicyUrl = ''
      this.form.appPermissionUrl = ''
      this.form.deeplink = ''
      this.form.packageName = ''
      this.form.showMonitor = ['']
      this.form.clickMonitor = ['']
      this.form.downloadStartMonitor = ['']
      this.form.downloadFinishMonitor = ['']
      this.form.installStartMonitor = ['']
      this.form.installFinishMonitor = ['']
      this.showMonitorTip = ''
      this.clickMonitorTip = ''
      this.downloadStartMonitorTip = ''
      this.downloadFinishMonitorTip = ''
      this.installStartMonitorTip = ''
      this.installFinishMonitorTip = ''
      this.showMonitorRule = null
      this.clickMonitorRule = null
      this.downloadStartMonitorRule = null
      this.downloadFinishMonitorRule = null
      this.installStartMonitorRule = null
      this.installFinishMonitorRule = null
      this.form.iconFile = ''
      this.form.logoFile = ''
      this.form.image1File = ''
      this.form.image2File = ''
      this.form.image3File = ''
      this.form.videoFile = ''
      this.iconPreview = ''
      this.logoPreview = ''
      this.image1Preview = ''
      this.image2Preview = ''
      this.image3Preview = ''
      this.videoPreview = ''
      this.iconErrorTip = ''
      this.logoErrorTip = ''
      this.image1ErrorTip = ''
      this.image2ErrorTip = ''
      this.image3ErrorTip = ''
      this.videoErrorTip = ''
      let data = this.ideaTypeList
      for (let val of data) {
        if (val.ideaTypeId === value) {
          this.assetsList = JSON.parse(val.assets)
          break
        }
      }
      for (let val of this.assetsList) {
        if (val.assetsId === 15) {
          this.showMonitorRule = val
        } else if (val.assetsId === 16) {
          this.clickMonitorRule = val
        } else if (val.assetsId === 23) {
          this.downloadStartMonitorRule = val
        } else if (val.assetsId === 24) {
          this.downloadFinishMonitorRule = val
        } else if (val.assetsId === 25) {
          this.installStartMonitorRule = val
        } else if (val.assetsId === 26) {
          this.installFinishMonitorRule = val
        }
        // 适配老版本img对象
        if (val.img) {
          val.data = val.img
          delete val.img
        }
      }
    },
    // 设置图标
    setImg (e, type, data) {
      let _this = this
      let img = e.target.files[0]
      if (!img) {
        return false
      }
      _this[type + 'Preview'] = ''
      _this.form[type + 'File'] = ''
      _this[type + 'ErrorTip'] = ''
      if (data.mimes.indexOf(img.type) < 0) {
        _this[type + 'ErrorTip'] = `图片暂不支持 ${img.type.replace(/image\//g, '').toUpperCase()} 格式`
        return false
      }
      let reader = new FileReader()
      reader.readAsDataURL(img)
      reader.onload = function (e) {
        let result = e.target.result
        var image = new Image()
        image.onload = function () {
          if (data.width && image.width !== parseInt(data.width)) {
            _this[type + 'ErrorTip'] = `图片宽度不符合限制宽度 ${data.width} px`
            return false
          }
          if (data.height && image.height !== parseInt(data.height)) {
            _this[type + 'ErrorTip'] = `图片高度不符合限制高度 ${data.height} px`
            return false
          }
          _this[type + 'Preview'] = result
          _this.form[type + 'File'] = img
          _this[type + 'ErrorTip'] = ''
          image = null
          reader = null
        }
        image.src = result
      }
    },
    // 删除图片
    removeImg (type) {
      this[`${type}Preview`] = ''
      this.form[`${type}File`] = ''
      this.$refs[`file_${type}`][0].value = null
    },
    // 设置视频
    setVideo (e, data) {
      let _this = this
      let video = e.target.files[0]
      if (!video) {
        return false
      }
      _this.videoPreview = ''
      _this.form.video = ''
      _this.videoErrorTip = ''
      if (data.mimes.indexOf(video.type) < 0) {
        _this.videoErrorTip = `视频暂不支持 ${video.type.replace(/video\//g, '').toUpperCase()} 格式`
        return false
      }
      let reader = new FileReader()
      reader.readAsDataURL(video)
      reader.onload = function (e) {
        let result = e.target.result
        var videoNode = document.createElement('video')
        videoNode.oncanplay = function () {
          let time = parseInt(videoNode.duration)
          if (data.width && videoNode.videoWidth !== parseInt(data.width)) {
            _this.videoErrorTip = `视频宽度不符合限制宽度 ${data.width} px`
            return false
          }
          if (data.height && videoNode.videoHeight !== parseInt(data.height)) {
            _this.videoErrorTip = `视频高度不符合限制高度 ${data.height} px`
            return false
          }
          if (data.minTime && time < parseInt(data.minTime)) {
            _this.videoErrorTip = `视频时长低于限制的最小时长 ${data.minTime} 秒`
            return false
          }
          if (data.maxTime && time > parseInt(data.maxTime)) {
            _this.videoErrorTip = `视频时长超出限制的最大时长 ${data.maxTime} 秒`
            return false
          }
          _this.videoPreview = result
          _this.form.video = video
          _this.videoErrorTip = ''
          videoNode = null
          reader = null
        }
        videoNode.src = result
      }
    },
    // 删除视频
    removeVideo () {
      this.videoPreview = ''
      this.form.video = ''
    },
    // 删除执行时间
    removeItem (item) {
      let index = this.form.executeTime.indexOf(item)
      if (index !== -1) {
        this.form.executeTime.splice(index, 1)
      }
    },
    // 增加执行时间
    addItem () {
      if (this.form.executeTime.length >= 5) {
        this.$message.warning('最多只能设置5组执行时间')
        return false
      }
      this.form.executeTime.push({
        value: '',
        radio: 0,
        key: Date.now()
      })
    },
    useApplyInfo (data) {
      // 有修改时，使用修改后的新idea信息，但查看时除外。
      return data.verifyIdeaInfo && this.isModel === 2 && !this.isViewMode
    },
    getDetail () {
      this.getIdeaTypeList()
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.thisModule.detail.id
        },
        url: this.myOption.requestUrl + this.thisModule.detail.api,
        data: this.qs.stringify({
          ideaId: this.id
        })
      }).then((res) => {
        let code = res.data.code
        if (code === 200) {
          let data = res.data.data
          this.detailInfo = _.cloneDeep(data)
          const originData = _.cloneDeep(data)
          if (this.useApplyInfo(data)) {
            data = data.verifyIdeaInfo
          }

          this.oldName = data.ideaName
          this.form.ideaName = data.ideaName
          this.form.unit = `${data.putUnitInfo.putUnitId}:${data.putUnitInfo.slotType}`
          this.unitList = [{putUnitId: `${data.putUnitInfo.putUnitId}:${data.putUnitInfo.slotType}`, putUnitName: data.putUnitInfo.putUnitName}]
          this.setUnit(this.form.unit)
          this.form.ideaType = data.ideaTypeInfo.ideaTypeId
          this.assetsList = JSON.parse(data.ideaTypeInfo.assets)
          for (let val of this.assetsList) {
            if (val.assetsId === 15) {
              this.showMonitorRule = val
            } else if (val.assetsId === 16) {
              this.clickMonitorRule = val
            } else if (val.assetsId === 23) {
              this.downloadStartMonitorRule = val
            } else if (val.assetsId === 24) {
              this.downloadFinishMonitorRule = val
            } else if (val.assetsId === 25) {
              this.installStartMonitorRule = val
            } else if (val.assetsId === 26) {
              this.installFinishMonitorRule = val
            }
            // 适配老版本img对象
            if (val.img) {
              val.data = val.img
              delete val.img
            }
          }
          this.form.bidType = data.bidType
          this.form.simulateBid = data.simulateBid
          this.form.dayShowNum = data.dayShowNum
          this.form.dayClickNum = data.dayClickNum
          this.form.remark = data.remark
          if (this.isSspUser) {
            this.form.advertiserId = data.putUnitInfo.advertiserId
          }
          let assets = JSON.parse(data.assets)
          for (let key in assets) {
            let value = assets[key]
            if (key === 'title' || key === 'desc' || key === 'rating' || key === 'comments' || key === 'targetUrl' || key === 'appName' || key === 'appDownUrl' || key === 'appVersion' || key === 'appDeveloper' || key === 'appFeatureUrl' || key === 'appPrivacyPolicyUrl' || key === 'appPermissionUrl' || key === 'deeplink' || key === 'packageName') {
              this.form[key] = value
            } else if (key === 'icon' || key === 'logo' || key === 'image1' || key === 'image2' || key === 'image3') {
              this[`${key}Preview`] = value.url
              this.form[`${key}File`] = this.$store.state.user.isCopy ? value.url : '没有修改'
            } else if (key === 'showMonitor' || key === 'clickMonitor' || key === 'downloadStartMonitor' || key === 'downloadFinishMonitor' || key === 'installStartMonitor' || key === 'installFinishMonitor') {
              this.form[key] = value.split(',')
            } else if (key === 'video') {
              this[`${key}Preview`] = value.video_url
              this.form[key] = this.$store.state.user.isCopy ? value.video_url : '没有修改'
            }
          }
          if (data.putUnitInfo.slotType === 8) {
            this.form.effectTime = new Date(parseInt(data.strategyInfo.effectTime) * 1000)
            this.form.expiredTime = new Date(parseInt(data.strategyInfo.expiredTime) * 1000)
            this.form.showRatio = parseInt(data.strategyInfo.showRatio)
            let executeTime = data.strategyInfo.executeTime.split(',')
            let executeRatio = data.strategyInfo.executeRatio.split(',')
            let executeTimeList = []
            for (let key in executeTime) {
              let time = parseInt(executeTime[key])
              let h = parseInt(time / 3600)
              let m = parseInt((time - h * 3600) / 60)
              let s = time - h * 3600 - m * 60
              executeTimeList.push({value: new Date(2019, 8, 7, h, m, s), radio: parseInt(executeRatio[key])})
            }
            this.form.executeTime = executeTimeList
            this.form.triggerWay = data.strategyInfo.triggerWay
            if (data.strategyInfo.triggerWay === 1) {
              this.form.timeWay = data.strategyInfo.timeWay
              if (data.strategyInfo.timeWay === 1) {
                this.form.speedTimes = data.strategyInfo.speedTimes
              } else if (data.strategyInfo.timeWay === 2) {
                this.form.timeBucket = data.strategyInfo.timeBucket
              }
            }
            // this.getUnitList()
          }
          this.form.verifyStatus = originData.verifyStatus
          this.form.verifyIdeaInfo = originData.verifyIdeaInfo
          this.form.updateFiledList = originData.updateFiledList
        } else {
          this.myOption.abnormalCode(this, code)
        }
        this.isLoading = false
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
        this.isLoading = false
      })
    },
    // 提交表单
    submitForm (formName, auditFlag) {
      this.$refs[formName].validate((valid) => {
        let state = 0
        if (this.showMonitorRule && !!this.showMonitorRule.required && this.form.showMonitor.join('') === '') {
          this.showMonitorTip = '请输入展示监控'
          state++
        } else if (this.showMonitorTip !== '') {
          state++
        } else {
          this.showMonitorTip = ''
        }

        if (this.clickMonitorRule && !!this.clickMonitorRule.required && this.form.clickMonitor.join('') === '') {
          this.clickMonitorTip = '请输入点击监控'
          state++
        } else if (this.clickMonitorTip !== '') {
          state++
        } else {
          this.clickMonitorTip = ''
        }

        if (this.downloadStartMonitorRule && !!this.downloadStartMonitorRule.required && this.form.downloadStartMonitor.join('') === '') {
          this.downloadStartMonitorTip = '请输入下载开始监控'
          state++
        } else if (this.downloadStartMonitorTip !== '') {
          state++
        } else {
          this.downloadStartMonitorTip = ''
        }

        if (this.downloadFinishMonitorRule && !!this.downloadFinishMonitorRule.required && this.form.downloadFinishMonitor.join('') === '') {
          this.downloadFinishMonitorTip = '请输入下载完成监控'
          state++
        } else if (this.downloadFinishMonitorTip !== '') {
          state++
        } else {
          this.downloadFinishMonitorTip = ''
        }

        if (this.installStartMonitorRule && !!this.installStartMonitorRule.required && this.form.installStartMonitor.join('') === '') {
          this.installStartMonitorTip = '请输入安装开始监控'
          state++
        } else if (this.installStartMonitorTip !== '') {
          state++
        } else {
          this.installStartMonitorTip = ''
        }

        if (this.installFinishMonitorRule && !!this.installFinishMonitorRule.required && this.form.installFinishMonitor.join('') === '') {
          this.installFinishMonitorTip = '请输入安装完成监控'
          state++
        } else if (this.installFinishMonitorTip !== '') {
          state++
        } else {
          this.installFinishMonitorTip = ''
        }

        let executeTimeValue = []
        let executeTimeRadioValue = []
        if (this.form.unit.split(':')[1] === '8') {
          let executeTime = this.form.executeTime
          let executeTimeRadio = 0
          for (let val of executeTime) {
            executeTimeRadio += val.radio
            if (val.value === '') {
              break
            }
            executeTimeValue.push(val.value.getHours() * 60 * 60 + val.value.getMinutes() * 60 + val.value.getSeconds())
            executeTimeRadioValue.push(val.radio)
          }
          if (executeTimeRadio !== 100) {
            this.$message.error('占比总和必须 =100')
            state++
          }
        }

        if (auditFlag) {
          if (!this.auditForm.auditResult) {
            this.auditResultTip = '请选择是否通过'
            state++
          } else {
            this.auditResultTip = ''
          }

          // if (this.auditForm.auditResult === 2 && !this.auditForm.auditReason) {
          //   utils.setFormItemError(this.$refs.auditForm, 'auditReason', '请填写审核不通过的原因')
          //   return
          // }
        }

        if (valid && state === 0) {
          this.isLoading = true
          let formData = new FormData()
          formData.append('ideaName', this.form.ideaName)
          formData.append('putUnitId', this.form.unit.split(':')[0])
          formData.append('ideaTypeId', this.form.ideaType)
          formData.append('bidType', this.form.bidType)
          formData.append('simulateBid', this.form.simulateBid)
          formData.append('remark', this.form.remark)
          if (this.form.dayShowNum) {
            formData.append('dayShowNum', this.form.dayShowNum)
          }
          if (this.form.dayClickNum) {
            formData.append('dayClickNum', this.form.dayClickNum)
          }
          formData.append('title', this.form.title)
          formData.append('desc', this.form.desc)
          formData.append('rating', this.form.rating)
          formData.append('comments', this.form.comments)
          formData.append('targetUrl', this.form.targetUrl)
          formData.append('appName', this.form.appName)
          formData.append('appDownUrl', this.form.appDownUrl)
          formData.append('appVersion', this.form.appVersion)
          formData.append('appDeveloper', this.form.appDeveloper)
          formData.append('appFeatureUrl', this.form.appFeatureUrl)
          formData.append('appPrivacyPolicyUrl', this.form.appPrivacyPolicyUrl)
          formData.append('appPermissionUrl', this.form.appPermissionUrl)
          formData.append('deeplink', this.form.deeplink)
          formData.append('packageName', this.form.packageName)

          let showMonitorData = []
          for (let val of this.form.showMonitor) {
            if (val !== '') {
              showMonitorData.push(val)
            }
          }

          let clickMonitorData = []
          for (let val of this.form.clickMonitor) {
            if (val !== '') {
              clickMonitorData.push(val)
            }
          }

          let downloadStartMonitorData = []
          for (let val of this.form.downloadStartMonitor) {
            if (val !== '') {
              downloadStartMonitorData.push(val)
            }
          }

          let downloadFinishMonitorData = []
          for (let val of this.form.downloadFinishMonitor) {
            if (val !== '') {
              downloadFinishMonitorData.push(val)
            }
          }

          let installStartMonitorData = []
          for (let val of this.form.installStartMonitor) {
            if (val !== '') {
              installStartMonitorData.push(val)
            }
          }

          let installFinishMonitorData = []
          for (let val of this.form.installFinishMonitor) {
            if (val !== '') {
              installFinishMonitorData.push(val)
            }
          }

          formData.append('showMonitor', showMonitorData.join(','))
          formData.append('clickMonitor', clickMonitorData.join(','))
          formData.append('downloadStartMonitor', downloadStartMonitorData.join(','))
          formData.append('downloadFinishMonitor', downloadFinishMonitorData.join(','))
          formData.append('installStartMonitor', installStartMonitorData.join(','))
          formData.append('installFinishMonitor', installFinishMonitorData.join(','))

          if (typeof (this.form.iconFile) === 'string') {
            formData.append('iconUrl', this.form.iconFile)
          } else {
            formData.append('iconFile', this.form.iconFile)
          }
          if (typeof (this.form.logoFile) === 'string') {
            formData.append('logoUrl', this.form.logoFile)
          } else {
            formData.append('logoFile', this.form.logoFile)
          }
          if (typeof (this.form.image1File) === 'string') {
            formData.append('image1Url', this.form.image1File)
          } else {
            formData.append('image1File', this.form.image1File)
          }
          if (typeof (this.form.image2File) === 'string') {
            formData.append('image2Url', this.form.image2File)
          } else {
            formData.append('image2File', this.form.image2File)
          }
          if (typeof (this.form.image3File) === 'string') {
            formData.append('image3Url', this.form.image3File)
          } else {
            formData.append('image3File', this.form.image3File)
          }
          if (typeof (this.form.video) === 'string') {
            formData.append('videoUrl', this.form.video)
          } else {
            formData.append('video', this.form.video)
          }
          if (this.form.unit.split(':')[1] === '8') {
            formData.append('effectTime', Date.parse(this.form.effectTime) / 1000)
            formData.append('expiredTime', Date.parse(this.form.expiredTime) / 1000)
            formData.append('showRatio', this.form.showRatio)
            formData.append('executeTime', executeTimeValue.join(','))
            formData.append('executeRatio', executeTimeRadioValue.join(','))
            formData.append('triggerWay', this.form.triggerWay)
            if (this.form.triggerWay === 1) {
              formData.append('timeWay', this.form.timeWay)
              if (this.form.timeWay === 1) {
                formData.append('speedTimes', this.form.speedTimes)
              } else if (this.form.timeWay === 2) {
                formData.append('timeBucket', this.form.timeBucket)
              }
            }
          }
          if (this.isModel === 2) {
            formData.append('ideaId', this.id)
            formData.append('updateIcon', this.form.iconFile !== '没有修改' || this.iconPreview === '' ? 1 : 0)
            formData.append('updateLogo', this.form.logoFile !== '没有修改' || this.logoPreview === '' ? 1 : 0)
            formData.append('updateImage1', this.form.image1File !== '没有修改' || this.image1Preview === '' ? 1 : 0)
            formData.append('updateImage2', this.form.image2File !== '没有修改' || this.image2Preview === '' ? 1 : 0)
            formData.append('updateImage3', this.form.image3File !== '没有修改' || this.image3Preview === '' ? 1 : 0)
            formData.append('updateVideo', this.form.video !== '没有修改' || this.videoPreview === '' ? 1 : 0)
          }
          if (this.isModel === 3) {
            formData.append('copyId', this.id)
          }
          if (this.isSspUser) {
            formData.append('advertiserId', this.form.advertiserId)
          }

          if (auditFlag) {
            this.doAudit(formData)
          } else {
            if (this.isModel === 2) {
              this.doUpdate(formData)
            } else {
              this.doAdd(formData)
            }
          }
        } else {
          return false
        }
      })
    },
    // 重置表单
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    doAdd (formData) {
      ideaAPI.add(formData).then(res => {
        this.isLoading = false
        this.$message.success(`${this.isModel === 2 ? '修改' : '新建'}创意成功`)
        this.$router.push({path: this.$route.path.replace('/edit', '/list')})
      }).catch(() => {
        this.isLoading = false
      })
    },
    doUpdate (formData) {
      ideaAPI.update(formData).then(res => {
        this.isLoading = false
        this.$message.success(`${this.isModel === 2 ? '修改' : '新建'}创意成功`)
        this.$router.push({path: this.$route.path.replace('/edit', '/list')})
      }).catch(() => {
        this.isLoading = false
      })
    },
    doAudit (formData) {
      formData.append('verifyStatus', this.auditForm.auditResult)
      formData.append('verifyFailReason', this.auditForm.auditReason)
      ideaAPI.updateAuditStatus(formData).then(res => {
        this.isLoading = false
        this.$message.success('操作成功')
        this.$router.push({path: this.$route.path.replace('/edit', '/list')})
      }).catch(() => {
        this.isLoading = false
      })
    },
    // 新增URL输入框
    setUrlInput (id) {
      this.form[id].push('')
    },
    // URL正则验证
    urlRule (id, text, index, obj) {
      this[`${id}Tip`] = ''
      let value = this.form[id][index]
      if (obj.required) {
        if (value === '') {
          this[`${id}Tip`] = `请输入${text}`
        } else if ((obj.min && value.length < obj.min) || (obj.max && value.length > obj.max)) {
          this[`${id}Tip`] = `长度在${obj.min}到${obj.max}字符`
        }
      } else {
        if (value !== '' && ((obj.min && value.length < obj.min) || (obj.max && value.length > obj.max))) {
          this[`${id}Tip`] = `长度在${obj.min}到${obj.max}字符`
        }
      }
    },
    // 删除URL输入框
    deleteValue (id, index) {
      this.form[id].splice(index, 1)
    }
  },
  // 组件销毁监听
  beforeDestroy () {
    this.$store.dispatch('SetEditId', false)
  }
}
</script>

<style scoped>
  .file {
    position: relative;
    display: inline-block;
    width: 319px;
    background: #fff;
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    padding: 10px;
    color: #bcbcbc;
    text-decoration: none;
    text-indent: 0;
    vertical-align: top;
    height: auto!important;
    min-height: 40px;
    cursor: pointer;
  }
  .img_preview {
    display: block;
  }
  .mt10{
    margin-top: 10px;
  }
  .mt10:first-child{
    margin-top: 0;
  }
  .file_taps{
    padding: 10px;
    line-height: 1.5;
    font-size: 12px;
    color: #606266;
    background-color: #F5F7FA;
  }

  .file_img{
    display: flex;
    justify-content: space-between;
  }
  .file_img>div:nth-child(1){
    padding: 6px;
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    font-size: 0;
    line-height: 0;
    width: 300px;
  }
  .file_img>div:nth-child(2){
    text-align: right;
    font-size: 0;
  }
  .file_img>div:nth-child(2)>a{
    display: inline-block;
    font-size: 12px;
    color: #aaa;
  }
  .file_img>div:nth-child(2) input[type='file'] {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    width: 100%;
    height: 100%;
    z-index: 9;
    font-size: 0;
  }
  .file_img>div:nth-child(2)>div:nth-child(1), .file_img>div:nth-child(2) a{
    position: relative;
    display: block;
    margin-bottom: 10px;
    cursor: pointer;
    background: #FFF;
    border: 1px solid #DCDFE6;
    color: #999;
    box-sizing: border-box;
    width: 44px;
    height: 32px;
    line-height: 30px;
    font-size: 12px;
    text-align: center;
    border-radius: 3px;
  }
</style>
<style>
  .el-image-viewer__btn.el-image-viewer__close{
    color: #fff!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/idea/Edit.vue